import type { SeoEntry } from "./seo-config";
import { API_URL } from "./supabase";
import { EMPTY_STATS, type SeoStats } from "./seo-format";

export type { SeoStats } from "./seo-format";
export { fmtBR, fmtPrice, EMPTY_STATS } from "./seo-format";

export type SeoListing = {
  id: string;
  source: string;
  title: string;
  display_title: string | null;
  year: number | null;
  km: number | null;
  price: number | null;
  url?: string;
  image_url?: string | null;
  photo_url?: string | null;
  thumbnail_url?: string | null;
  location?: string | null;
  city?: string | null;
  state?: string | null;
  armorer?: string | null;
  blindadora?: string | null;
  detected_at?: string | null;
  first_seen_at?: string | null;
  created_at?: string | null;
};

export type SeoPageData = {
  entry: SeoEntry;
  listings: SeoListing[];
  stats: SeoStats;
};

export type SeoListingsResponse = {
  listings: SeoListing[];
  stats: SeoStats;
};

const EMPTY_RESPONSE: SeoListingsResponse = { listings: [], stats: EMPTY_STATS };

export async function fetchSeoListings(
  entry: SeoEntry,
  locationOverride?: string,
): Promise<SeoListingsResponse> {
  const params = new URLSearchParams();
  const effectiveLocation = locationOverride ?? entry.location;
  if (effectiveLocation) params.set("location", effectiveLocation);
  if (!entry.location || locationOverride) {
    // Prefer `family` (indexed base_family/model_slug equality on the matview).
    // Fall back to terms ILIKE only for entries without a clean family mapping
    // (brand pages, toyota-sw4) — those hit the trigram GIN indexes.
    if (entry.family) {
      const families = Array.isArray(entry.family) ? entry.family : [entry.family];
      for (const fam of families) params.append("family", fam);
    } else {
      if (!entry.match.length) return EMPTY_RESPONSE;
      for (const term of entry.match) params.append("term", term);
    }
  }
  try {
    const res = await fetch(`${API_URL}/api/seo/listings?${params}`);
    if (!res.ok) return EMPTY_RESPONSE;
    return res.json();
  } catch {
    return EMPTY_RESPONSE;
  }
}
